jQuery(document).ready(function($) {
	
	var windowWidth = $(window).width();
	
	if (windowWidth >= 801) {
		$('.tabs-component').addClass('desktop').removeClass('mobile');
		$('.tabs-component .accordion').accordion('destroy');
		$('.tabs-component').tabs();
	} else {
		$('.tabs-component').addClass('mobile').removeClass('desktop');
	}

	(function($,sr){
	
	  // debouncing function from John Hann
	  // http://unscriptable.com/index.php/2009/03/20/debouncing-javascript-methods/
	  var debounce = function (func, threshold, execAsap) {
		  var timeout;
	
		  return function debounced () {
			  var obj = this, args = arguments;
			  function delayed () {
				  if (!execAsap)
					  func.apply(obj, args);
				  timeout = null;
			  };
	
			  if (timeout)
				  clearTimeout(timeout);
			  else if (execAsap)
				  func.apply(obj, args);
	
			  timeout = setTimeout(delayed, threshold || 100);
		  };
	  }
	  // smartresize 
	  jQuery.fn[sr] = function(fn){  return fn ? this.bind('resize', debounce(fn)) : this.trigger(sr); };
	
	})(jQuery,'smartresize');
	
	
	$(window).smartresize(function(){
		
		var windowWidth = $(window).width();
		
		$('.tabs-component').each(function() {
			
			if (windowWidth >= 801) {
				
				if ($(this).hasClass('mobile')) {
					$(this).find('.accordion').accordion('destroy');
					$(this).tabs();
					$(this).addClass('desktop').removeClass('mobile');
				}
				
			} else {
				
				if ($(this).hasClass('desktop')) {
					$(this).tabs('destroy');
					$(this).find('.accordion').accordion({
						collapsible: true,
						active: false,
						heightStyle: 'content'
					});
					$(this).addClass('mobile').removeClass('desktop');
				}
				
			}
			
		});
		
	});
	
});